var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSui(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0242 10.0095L18.0238 10.0105C19.0029 11.2382 19.5881 12.7932 19.5881 14.4845C19.5881 16.2009 18.9854 17.777 17.9799 19.013L17.8933 19.1195L17.8703 18.9842C17.8508 18.8692 17.8278 18.7531 17.8012 18.636C17.298 16.4249 15.6584 14.529 12.9598 12.9938C11.1375 11.96 10.0944 10.7151 9.82058 9.30072C9.64373 8.38613 9.77522 7.46748 10.0293 6.68062C10.2834 5.89402 10.6613 5.23498 10.9823 4.83821L10.9825 4.83794L12.0323 3.55433C12.2164 3.32923 12.5609 3.32923 12.745 3.55433L18.0242 10.0095ZM19.6846 8.72705L19.6848 8.72657L12.6487 0.123202C12.5144 -0.0410672 12.2628 -0.0410672 12.1285 0.123202L5.09233 8.72666L5.09252 8.72714L5.06963 8.75554C3.77484 10.3622 3 12.4041 3 14.6268C3 19.8034 7.20334 24 12.3886 24C17.5739 24 21.7772 19.8034 21.7772 14.6268C21.7772 12.4041 21.0024 10.3623 19.7076 8.75554L19.6846 8.72705ZM6.77587 9.98177L6.77616 9.98143L7.40549 9.21187L7.42452 9.35395C7.43959 9.46649 7.45786 9.5796 7.47953 9.69322C7.88674 11.8297 9.3414 13.6112 11.7734 14.991C13.8875 16.1942 15.1183 17.5777 15.473 19.0951C15.621 19.7284 15.6473 20.3514 15.5832 20.8962L15.5793 20.9299L15.5488 20.9448C14.5946 21.4109 13.522 21.6726 12.3884 21.6726C8.41222 21.6726 5.18872 18.4544 5.18872 14.4845C5.18872 12.78 5.78294 11.2139 6.77587 9.98177Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSui);
export default __webpack_public_path__ + "static/media/sui.394aae374257b26348d94dbaf8eaa121.svg";
export { ForwardRef as ReactComponent };